export interface U3141UseFetchHistoriqueCadastralHandlersParams {
  doFetchHistoriqueCadastralFn: (masterLotChainId: string) => Promise<{ data: { id?: string; status?: string } }>;
  onSuccess?: (jobId: string) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseFetchHistoriqueCadastralHandlersReturn {
  fetchHistoriqueCadastral: (masterLotChainId: string) => Promise<void>;
}

export function useU3141UseFetchHistoriqueCadastralHandlers({
  doFetchHistoriqueCadastralFn,
  onSuccess,
  onError,
}: U3141UseFetchHistoriqueCadastralHandlersParams): U3141UseFetchHistoriqueCadastralHandlersReturn {
  const fetchHistoriqueCadastral = async (masterLotChainId: string) => {
    try {
      const response = await doFetchHistoriqueCadastralFn(masterLotChainId);
      const data = response?.data as Record<string, unknown> | undefined;
      const result = (data?.result ?? data?.data) as Record<string, unknown> | undefined;
      const rawId = data?.id ?? result?.id;
      const jobId = typeof rawId === "string" ? rawId : "";

      onSuccess?.(jobId);
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { fetchHistoriqueCadastral };
}
